export default __webpack_public_path__ + "de99a66e350faa338a68f5d94c5c7d15.png";